import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bdf7d76c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal is-active centered"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = { class: "modal-card" }
const _hoisted_4 = { class: "modal-card-head" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "is-flex is-flex-shrink-0" }, null, -1))
const _hoisted_6 = { class: "modal-card-title is-title-shrink" }
const _hoisted_7 = { class: "modal-card-body" }
const _hoisted_8 = { class: "modal-card-foot is-justify-content-flex-end" }
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("header", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.opts.title), 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelInput()))
            })
          ]),
          _createElementVNode("section", _hoisted_7, [
            _createElementVNode("p", null, _toDisplayString(_ctx.opts.content), 1)
          ]),
          _createElementVNode("footer", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opts.buttons, (button) => {
              return (_openBlock(), _createElementBlock("div", {
                key: button.id
              }, [
                _createElementVNode("button", {
                  class: "button custom-button custom-inverted ml-2",
                  onClick: ($event: any) => (_ctx.submitInput(button.id))
                }, _toDisplayString(button.label), 9, _hoisted_9)
              ]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}